export enum MenuRootPathEnum {
  MY_TASK = "/my-task",
  VOCS_INVENTORY = "/vocs-inventory",
  PRODUCTION = "/production",
  TARGET = "/target",
  REPORT = "/report",
  DASHBOARD = "/dashboard",
  STATUS = "/status",
  SETTING = "/setting",
}

export enum SettingMasterdataEnum {
  COMBUSTION = "combustion",
  FLARE = "flare",
  FLARE_INFORMATION = "flare-information",
  FLARE_COMPOUND = "flare-compound",
  TRANSPORTATION_AND_MARKETING = "transportation-and-marketing",
  TRANSPORTATION_AND_MARKETING_CHEMICAL = "transportation-and-marketing-chemical",
  TRANSPORTATION_AND_MARKETING_LOADING_METHOD = "transportation-and-marketing-loading-method",
  TRANSPORTATION_AND_MARKETING_EMISSION_CONTROL = "transportation-and-marketing-emission-control",
  FUGITIVE = "fugitive",
  FUGITIVE_STATUS = "fugitive-status",
  FUGITIVE_EQUIPMENT_TYPE = "fugitive-equipment-type",
  FUGITIVE_UNCHECK = "fugitive-uncheck",
  FUGITIVE_STD_CONTROL = "fugitive-std-control",
  FUGITIVE_COMPONENT_BY_SERIES = "fugitive-component-by-series",
  TANK = "tank",
  TANK_TANK_TYPE = "tank-tank-type",
  TANK_EMISSION_CONTROL = "tank_emission_control",

  WASTE_WATER_TREATMENT = "waste-water-treatment",
}

export enum UnGroupThirdLevelMenuEnum {
  CALCULATION = "CALCULATION",
}

export enum CommonError {
  SOMETHING_WRONG = "Something went wrong.",
  SUBMIT_FAIL = "Submit fail.",
  APPROVED_FAIL = "Approved fail.",
}

export enum CommonSuccess {
  SAVED_SUCCESSFULL = "Saved successfully.",
  DELETE_SUCCESSFULL = "Deleted successfully.",
  SUBMIT_SUCCESSFULL = "Submit Successfully.",
  APPROVED_SUCCESSFULL = "Approved successfully.",
  REJECT_SUCCESSFULL = "Rejected successfully.",
  SENDMAIL_SUCCESSFULL = "Sent successfully.",
}
